<template>
<!--    交付表-->
    <div class="rf">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <div class="formDiv">

                <div class="item">
                    <el-form-item class="form-title" prop="wtname" :label="$t('form_entrust_company')" >
                        <el-input  v-model="formData.wtname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="gsname" :label="$t('promanagement_processing_unit')" >
                        <el-input  v-model="formData.gsname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="bmname" :label="$t('promanagement_processing_department')" >
                        <el-input  v-model="formData.bmname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title num" prop="num" label="No:" >
                        <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                    </el-form-item>
                </div>
                <div class="item">
                    <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                        <el-input  v-model="formData.ckname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="ccpro" :label="$t('form_finished_goods')" >
                        <el-input  v-model="formData.ccpro" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="jgcost" label="加工费" >
                        <el-input  v-model.number="formData.jgcost" :disabled="disabled">
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="bzcost" label="包装费" >
                        <el-input  v-model.number="formData.bzcost" :disabled="disabled">
                        </el-input>
                    </el-form-item>
                </div>
            </div>
            <div style="margin-bottom: 20px">
                <template>
                    <el-row>{{$t('promanagement_output_delivery_details')}}</el-row>
                    <el-table
                        border
                        size="mini"
                        ref="multipleTable"
                        :data="jftableData"
                        height="241"
                        :row-class-name="tableRowClassName"
                        tooltip-effect="dark"
                        style="width: 100%;">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_ingsname"
                            :label="$t('form_goods_rights_company')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_no"
                            :label="$t('form_batch_number')"
                    width="200"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="f_outnum"
                            :label="$t('form_delivery_quantity')"
                            width="100"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_note"
                            label="说明"
                            width="100"
                            show-overflow-tooltip>
                    </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_pno"
                                :label="$t('promanagement_production_task_number')"
                                width="120"
                                show-overflow-tooltip>
                        </el-table-column>
                </el-table>
                </template>
                <template>
                    <el-row>总消耗明细</el-row>
                    <el-table
                            border
                            size="mini"
                            ref="multipleTable"
                            :data="xhtableData"
                            height="296"
                            :row-class-name="tableRowClassName"
                            tooltip-effect="dark"
                            style="width: 100%;">
                        <el-table-column
                                :label="$t('form_serial_number')"
                                align="left"
                                type="index"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_hqgsname"
                                :label="$t('form_goods_rights_company')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_pzname"
                                label="原辅料名"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_no"
                                :label="$t('form_batch_number')"
                    width="200"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_unit"
                                :label="$t('form_metering')"
                                width="80"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="f_cbprice"
                                label="单价"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="f_innum"
                                label="实际消耗量"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="f_require"
                                label="需求量"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="f_cb"
                                label="成本"
                                width=""
                                show-overflow-tooltip>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" disabled>
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" v-if="edit==false" class="dialog-footer" style="text-align: center">

            <el-button type="primary" @click="saveForm" v-if="i_state==0" :class="baseerp+'btn'">保存并提交</el-button>
            <el-button type="success" @click="renderForm" v-if="i_state==1" >交付</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./../api"

    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "RenderForm",
        props:{
            render:{
                type:Object,
                required: true,
            }
        },
        data() {
            return {
                edit:false,
                jgcost:"",
                bzcost:"",
                formData:{
                    gsname:"",
                    bmname:"",
                    jgcost:"",
                    wtname:"",
                    pcnum:"",
                    jfnum:"",
                    ccpro:"",
                    ckname:"",
                    num:"000000",
                    vc_note:"",
                    vc_lruname: sessionStorage.getItem("lruname"),
                    date:"",
                    jftableData:[],
                    xhtableData:[],
                    bzcost:"",
                },
                formRules:{
                    jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                },
                jftableData:[],
                xhtableData:[],
                disabled:false,
                baseerp:"",
                i_id:0,
                f_outnum:0,
                i_outid:0,
                form:{},
                formList:[],
                vc_plat:"",
                i_state:"",
                jfsum:0,
                ids:[],
                mid:0,
            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.title=this.render.title;
            this.formList=this.render.value;
            this.mid=this.render.i_mid;
            if (this.title=="批量提交单"){
                this.plassignment();
                this.edit=false;
                this.disabled=false;
            }else{
                this.assignment();
            }

        },
        methods: {
            //批量
            plassignment() {
                /*this.formList = [
                    {details: [{jfnum: 1.1, name: "j"}, {jfnum: 1, name: "j"}], name: {qname: "a"}},
                    /!*{details: [{jfnum: 3.03, name: "j"}, {jfnum: 1, name: "j"}], name: {qname: "d"}},
                    {details: [{jfnum: 3.253, name: "j"}, {jfnum: 1, name: "j"}], name: {qname: "l"}},
                    {details: [{jfnum: 9.589, name: "j"}, {jfnum: 1, name: "t"}], name: {qname: "v"}},*!/
                ]*/
                /*if (this.formList.length == 1) {
                    this.jftableData = this.formList[0].details;
                } else {
                    let arr = this.formList.reduce((pre, cur) =>
                        Array.isArray(pre) ? [...pre, ...cur.details] : [...pre.details, ...cur.details]
                    );
                    this.jftableData = arr;
                }*/
                this.jftableData=[...this.jftableData,...this.formList];
                this.ids=this.formList.reduce((pre,cur)=>[...pre,cur.i_id],[]);
                this.vc_plat=this.formList[0].vc_plat;
                this.jfsum=this.formList.reduce((pre,cur)=>this.$math.add(pre, cur.f_outnum), 0);
                // console.log("this.ids")
                this.formData = {
                    gsname: this.formList[0].vc_outgsname,
                    bmname: this.formList[0].vc_gname,
                    jgcost: this.$math.multiply(this.jfsum,this.formList[0].f_jgmoney),
                    wtname: this.formList[0].vc_ingsname,
                    pcnum: this.formList[0].vc_no,
                    ccpro: this.formList[0].vc_pzname,
                    ckname: this.formList[0].vc_ckname,
                    num: this.formList[0].i_outid,
                    vc_note: this.formList[0].vc_jfnote,
                    vc_lruname: sessionStorage.getItem("lruname"),
                    date: this.formList[0].dt_lrcreatetime,
                };

                this.getConsumeList();
                // this.getProduceOdd();
                // console.log(this.jfsum,"======jfsum")
            },
            //赋值
            assignment() {
                this.jftableData=[...this.jftableData,this.formList];
                this.vc_plat = this.formList.vc_plat;
                this.i_state = this.formList.i_state;
                this.i_outid = this.formList.i_outid;
                this.i_id = this.formList.i_id;
                this.ids=[...this.ids,this.i_id];
                this.jfsum = this.formList.f_outnum;
                this.formData = {
                    gsname: this.formList.vc_outgsname,
                    bmname: this.formList.vc_gname,
                    jgcost: this.$math.multiply(this.jfsum,this.formList.f_jgmoney),
                    wtname: this.formList.vc_ingsname,
                    pcnum: this.formList.vc_no,
                    jfnum: this.formList.f_outnum,
                    ccpro: this.formList.vc_pzname,
                    ckname: this.formList.vc_ckname,
                    num: this.formList.i_outid,
                    vc_note: this.formList.vc_jfnote,
                    vc_lruname: sessionStorage.getItem("lruname"),
                    date: this.formList.dt_lrcreatetime,
                };
                if (this.title == "查看交付单" || this.title == "产品查看") {
                    this.getProduceOdd();
                    this.edit = true;
                    this.disabled = true;
                } else if (this.title == "提交交付单") {
                    this.getProduceOdd();
                    //this.getConsumeList();
                    this.edit = false;
                    this.disabled = true;
                } else if (this.title == "产品提交") {
                    this.getConsumeList();
                    this.edit = false;
                    this.disabled = false;
                }

                if (this.title == "产品产出" && this.i_state == -1) {
                    this.i_outid = '0'
                }
            },
            //获取消耗列表
            async getConsumeList() {
                let param = {
                    ids: this.ids,
                    i_mid: this.mid,
                    jfsum: this.jfsum,
                    vc_plat: this.vc_plat,
                }
                let res = await API.getConsumeList(param);
                if (res.code == 1) {
                    this.xhtableData = res.data;
                    this.formData.xhtableData = res.data;
                    this.formData.bzcost = res.bzfy;
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }

            },
            //查看
            async getProduceOdd() {
                let param = {
                    i_outid: this.i_outid,
                    i_mid: this.mid,
                }
                let res = await API.getProduceOdd(param);
                if (res.code == 1) {
                    this.formData = {
                        gsname: res.data.vc_outgsname,
                        bmname: res.data.vc_gname,
                        jgcost: res.data.f_jgmoney,
                        wtname: res.data.vc_ingsname,
                        pcnum: res.data.vc_no,
                        jfnum: res.data.f_num,
                        ccpro: res.data.vc_pzname,
                        ckname: res.data.vc_ckname,
                        num: res.data.i_outid,
                        vc_note: res.data.vc_jfnote,
                        vc_lruname: res.data.vc_lruname,
                        date: res.data.dt_createtime,
                        bzcost: res.data.f_bzfee,
                    };
                    this.jftableData = res.data.prouses;
                    this.formData.jftableData = res.data.prouses;
                    this.formData.xhtableData = res.data.details;
                    this.xhtableData = res.data.details;
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }

            },
            async renderForm() {
                let param = {
                    i_outid: this.i_outid,
                    i_mid: this.mid,
                }
                let res = await API.commitProduceOdd(param);
                if (res.code == 1) {

                    this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //保存
            async saveForm() {
                //console.log(this.tableData,"------")
                let param = {
                    i_mid: this.mid,
                    i_outid: this.jftableData[0].i_outid,
                    i_outgsid: this.jftableData[0].i_outgsid,
                    i_ingsid: this.jftableData[0].i_ingsid,
                    i_gid: this.jftableData[0].i_gid,
                    i_ckid: this.jftableData[0].i_ckid,
                    i_rwid: this.jftableData[0].i_rwid,
                    i_pzid: this.jftableData[0].i_pzid,
                    f_jgmoney: this.formData.jgcost,
                    vc_jfuname: "zyh",
                    i_jfuid: "42",
                    i_state: this.jftableData[0].vc_state,
                    vc_note: this.formData.vc_note,
                    vc_plat: this.jftableData[0].vc_plat,
                    details: this.formData.xhtableData,
                    prouses: this.jftableData,
                    f_bzfee:this.formData.bzcost,
                };
                let res = await API.saveProduceOdd(param);
                if (res.code == 1) {
                    let value = {
                        wtgsid: this.jftableData[0].i_ingsid,
                        pageSize: this.render.page_size,
                    }
                    this.$emit('getProduceList', value)
                    this.$message.success(res.message);
                    this.disabled = true;
                    this.cancel();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            tableRowClassName({row, rowIndex}) {
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
            cancel() {
                //console.log(this.pageSize,"------")
                this.$emit('close');

                //this.$emit('getEntrustCompanyHaveList')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    /deep/{
        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        .danger-row{
            color: #999;
        }
    }
</style>